.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

.search {
  display: flex;
  gap: var(--space-2);
  align-items: center;
  padding: 0 var(--space-2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-input);
  color: var(--color-text-muted);
}

.search:focus-within {
  border-color: var(--color-focus);
  outline: 2px solid var(--color-focus);
  outline-offset: 0;
}

.search input {
  flex: 1;
  min-width: 0;
  min-height: 2.25rem;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;
  color: var(--color-text);
}

/* As many columns as fit: one tall list is unusable with 100 labels. */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 8.5rem), 1fr));
  gap: var(--space-1);
  max-height: 16rem;
  padding: 2px;
  overflow-y: auto;
}

.option {
  position: relative;
  display: flex;
  gap: var(--space-1);
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  min-height: 2rem;
  padding: 0 var(--space-2);
  overflow: hidden;
  border: none;
  border-radius: var(--radius-sm);
  font-size: var(--font-size-sm);
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}

.option:hover:not(:disabled) {
  filter: brightness(1.08);
}

.option:focus-visible {
  outline: 2px solid var(--color-focus);
  outline-offset: 2px;
}

/* Selected: a thin white ring (visible on the colored chip and on the dark popover) + a check. */
.selected {
  box-shadow:
    0 0 0 1px rgb(0 0 0 / 55%),
    0 0 0 2px #fff;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.check {
  display: inline-flex;
  flex: none;
}

.empty {
  margin: 0;
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
}
